/* eslint-disable react/require-default-props */
import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { useTheme } from 'styled-components'

import {
  checkExternalUrl,
  normalizeExternalUrl,
  normalizeInternalUrl,
} from 'utils/urlUtils'
import Button from 'components/Button'
import { ChevronIcon } from 'components/Icons'
import Link from 'components/Link'

import {
  Benefit,
  CarouselItem,
  Copy,
  ImageContainer,
  InfoBox,
  RoundBox,
  Title,
} from './ServiceItem.style'

const ServiceItem = ({
  image,
  heading,
  benefit,
  bodyCopy,
  url,
  handleClick,
  ctaLabel,
  external,
  villageSlug = '',
  nodeLocale = '',
}) => {
  const {
    colors: { secondary },
  } = useTheme()

  const hasCTA = ctaLabel && url

  const ctaUrl =
    external || checkExternalUrl(url)
      ? normalizeExternalUrl(url)
      : `/${villageSlug}/${nodeLocale}${normalizeInternalUrl(url)}`

  return (
    <CarouselItem>
      <ImageContainer
        image={image?.portrait?.gatsbyImageData}
        alt={image?.altText || ''}
      />
      <InfoBox>
        <Title>{heading}</Title>
        <Benefit>{benefit}</Benefit>
        {bodyCopy?.bodyCopy && <Copy html={bodyCopy.bodyCopy} />}
        {hasCTA && (
          <Button as={Link} to={ctaUrl}>
            {ctaLabel}
          </Button>
        )}
      </InfoBox>
      {isMobile && (
        <RoundBox onClick={handleClick}>
          <ChevronIcon
            width={[15]}
            height={[15]}
            transform="rotate(180deg)"
            color={secondary}
          />
        </RoundBox>
      )}
    </CarouselItem>
  )
}

ServiceItem.propTypes = {
  image: PropTypes.shape({
    headline: PropTypes.string,
    altText: PropTypes.string,
    landscape: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }),
    }),
    portrait: PropTypes.shape({
      gatsbyImageData: PropTypes.shape({
        aspectRatio: PropTypes.number.isRequired,
        src: PropTypes.string.isRequired,
        srcSet: PropTypes.string.isRequired,
        srcSetWebp: PropTypes.string.isRequired,
        sizes: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  heading: PropTypes.string.isRequired,
  benefit: PropTypes.string.isRequired,
  bodyCopy: PropTypes.shape({
    bodyCopy: PropTypes.string,
  }).isRequired,
  url: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  ctaLabel: PropTypes.string,
  external: PropTypes.bool,
  villageSlug: PropTypes.string,
  nodeLocale: PropTypes.string,
}

export default ServiceItem
